module.exports = __webpack_public_path__ + "static/media/R-Smart MotorE.7b61b1bd.jpg";